/**
 * @file main.tsx
 * @description Компонент для подложки основного интерфейса.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react-router-dom, @components/left-menu, @components/header, @components/icons]
 * @related-files ['@components/icons.top-menu', '@components/left-menu', '@components/header', '@components/left-menu/submenu/submenu.component']
 */

import { Menu } from '@components/left-menu';
import { Header } from '@components/header';
import { Link, Outlet } from 'react-router-dom';
import { TopMenuIcon } from '@components/icons';
import Submenu from '@components/left-menu/submenu/submenu.component';

export const Main = () => {
    return (
        <div id="MainLayout_Wrapper" className="-MainLayout_Wrapper flex">
            <div className="MainLayout_Left z-[2] flex w-[28.5867vmin] min-w-[28.5867vmin]">
                <div className="flex flex-col w-[28.5867vmin] bg-[#265078] absolute h-full z-[2]">
                    <div className="-MainLayout_Left_Logo flex items-center justify-center text-[3.8116vmin] text-white cursor-pointer">
                        <Link to="/">
                            <TopMenuIcon />
                        </Link>
                    </div>

                    <div className="h-full z-[10]">
                        <Menu />
                    </div>
                </div>

                <Submenu />
            </div>

            <div className="-MainLayout_Right flex flex-col flex-1 h-[100vh] w-full z-[1]">
                <div className="-MainLayout_Right_Header">
                    <Header />
                </div>

                <div className="-MainLayout_Right_Main flex-1 bg-default-bg p-[2.1171vmin] h-full w-full">
                    <div className="relative h-full w-full">
                        <div id="MainLayout" className="absolute w-full h-full">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
